import React from "react";
import classNames from "classnames";
import Image from "../../../elements/image";
import { mobileIs } from "../../../utils/siteUtils";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
const ImageOverlayImageV2 = props => {
  const { index, item } = props;
  const isMobile = mobileIs();
  const autoHeightClasses =  isMobile?  (item?.fields?.m_full_height?.value == true? "auto-height-m": "") : (item?.fields?.pc_full_height?.value == true? "auto-height" : "");

  return (
    <div key={index} className={classNames("image-overlay-image-v2", autoHeightClasses)} >
      <Image className="image" {...isMobile ? item?.fields?.m_image?.value : item?.fields?.pc_image?.value} />

      <RichText className="title" field={isMobile ? item?.fields?.m_text : item?.fields?.pc_text} />
    </div>
  )
};
export default ImageOverlayImageV2;
